import client from "./serviceClient";

const saveFInanceAnswers = (params) => client.post(`/business/questions/save-answers`, { ...params });


export default {
    saveFInanceAnswers,
 
};